import { Component, createRef } from 'react';

import IconHeart from '../Icons/IconHeart';
import IconLogin from '../Icons/IconLogin';

import {
  headerTopMenu,
  headerBottomMenu,
  headerClubs,
} from '../CommonData/headerMenu';

import './styles/headerMobile.scss';
import {linkWithUtm} from "../../helpers/linkWithUtm";
import IconPhone from "../Icons/IconPhone";

const MAX_MOBILE_WIDTH = 700;
const MAX_TABLET_WIDTH = 1200;

class HeaderMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobile: null,
      lastScrollTop: 0,
      headerHide: false,
      isMainpage: false,

      clubList: false,

      statusMenu: false,
      searchValue: '',
      searchScreen: false,
      clubsScreen: false,
      clubsScreenVisited: false,
      supportScreen: false,
      supportScreenVisited: false
    };

    this.searchInput = createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    window.addEventListener('resize', this.mobileStatus.bind(this));

    this.setState({
      isMainpage: false
    });

    this.mobileStatus();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    window.removeEventListener('resize', this.mobileStatus.bind(this));
  }

  handleScroll() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.state.lastScrollTop) {
      // downscroll code
      if (scrollTop > 100) {
        this.setState(
          {
            headerHide: false
          },
          () => {
            // close select club on tablet
            if (
              window.innerWidth > MAX_MOBILE_WIDTH &&
              window.innerWidth < MAX_TABLET_WIDTH &&
              this.props.status
            ) {
              this.props.openCloseClubList();
            }
          }
        );
      }
    } else {
      // upscroll code
    }

    this.setState({
      lastScrollTop: scrollTop <= 0 ? 0 : scrollTop
    });
  }

  toggleMenu() {
    this.setState(
      {
        statusMenu: !this.state.statusMenu
      },
      () => {
        // rewrite
        if (this.state.statusMenu) {
          document.querySelector('body').classList.add('no-scroll');
          document
            .querySelector('.site-content')
            .classList.add('_tablet-layer');
        } else {
          document.querySelector('body').classList.remove('no-scroll');
          document
            .querySelector('.site-content')
            .classList.remove('_tablet-layer');
          this.returnBack();
        }
      }
    );
  }

  toogleClubList() {
    this.setState({
      clubList: !this.state.clubList
    });
  }

  setSearchvValue(event) {
    this.setState({
      searchValue: event.target.value
    });
  }

  openSearchScreen() {
    if (window.innerWidth < MAX_TABLET_WIDTH && window.location.pathname === '/search') {
      this.toggleMenu();
      return false;
    }
    this.searchInput.current.focus();
    this.setState({
      searchScreen: true
    });
  }

  openClubsScreen() {
    this.setState({
      clubsScreen: true,
      clubsScreenVisited: true,
    });
  }

  openSupportScreen() {
    this.setState({
      supportScreen: true,
      supportScreenVisited: true
    });
  }

  returnBack() {
    this.setState({
      searchScreen: false,
      clubsScreen: false,
      supportScreen: false
    });
  }

  mobileStatus() {
    this.setState(
      {
        mobile: window.innerWidth <= MAX_TABLET_WIDTH
      },
      () => {
        !this.state.mobile && this.state.statusMenu && this.toggleMenu();
      }
    );
  }

  render() {
    const {
      promo,
      article,
      isVisibleInfoPanel,
    } = this.props;

    return (
      <>
        <div
          className={`header-mobile ${this.state.headerHide ? isVisibleInfoPanel ? '_hide-info' : '_hide' : ''} ${
            this.state.statusMenu && '_tablet-layer'
          }`}
        >
          {/*
          <div className={`header-mobile__info ${isVisibleInfoPanel ? '' : '_hide'}`}>
            <a href="https://space.fitron.club/reopen" target="_blank" rel="nofollow noopener" className="header-mobile__info__link-mobile"></a>
            <button className="header-mobile__info__close" onClick={() => closeInfoPanel()}>
              <img src={require('../../../public/static/images/icons/info-panel-close.svg')} alt=""/>
            </button>
            <div className="header-mobile__info__content">
              <p>Принимаем необходимые меры безопасности во&nbsp;всех клубах сети FITRON</p>
              <a href="https://space.fitron.club/reopen" target="_blank" rel="nofollow noopener">Узнать больше</a>
            </div>
          </div>
          */}
          <div className="header-mobile__panel">
            <div className="header-mobile__panel__item">
              <div itemScope itemType="http://schema.org/Organization" className="header-mobile__logo">
                <a itemProp="url" href={linkWithUtm('https://fitron.club/')} className="header-mobile__logo">
                  <img itemProp="logo" src={require('../../static/images/fitron-logo.svg').default} alt="" />
                </a>
                <meta itemProp="name" content="Fitron" />
                <meta itemProp="address" content="Ростов-на-Дону" />
                <meta itemProp="telephone" content="+7 (863) 301-2000" />
              </div>
            </div>
            <div className="header-mobile__panel__item">
              <a href="tel:+78633012000" className={`header-mobile__phone`}>
                <IconPhone />
              </a>
              <a href="https://login.fitron.club/" target="_blank" rel="nofollow noopener" className={`header-mobile__user`}>
                <IconLogin />
              </a>
              <button
                className={`header-mobile__menu ${
                  this.state.statusMenu && '_open'
                }`}
                onClick={this.toggleMenu.bind(this)}
              >
                <div className="header-mobile__menu__icon">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div className={`menu-mobile ${this.state.statusMenu && '_open'}`}>
          <div className="menu-mobile__control">
            <button
              className={`btn-back ${
                !(
                  this.state.searchScreen ||
                  this.state.clubsScreen ||
                  this.state.supportScreen
                ) && '_hide'
              }`}
              onClick={this.returnBack.bind(this)}
            >
              <img
                src={require('../../static/images/icons/arrow-top.svg').default}
                alt=""
              />
            </button>
            <button
              className="btn-close"
              onClick={this.toggleMenu.bind(this)}
            >
              <span></span>
              <span></span>
            </button>
          </div>
          <div className="menu-mobile__body">
            <div className="menu-mobile__main menu-mobile__tab _active">
              <div className="menu-mobile__tab__content">
                <div
                  className={`menu-mobile__main__club mobile-select-club ${
                    this.state.clubList && '_active'
                  }`}
                >

                </div>
                <div className="menu-mobile__main__list">
                  <ul>
                    <li key="1">
                      <button
                        onClick={this.openClubsScreen.bind(this)}
                      >
                        <span>Клубы</span>
                        <img
                          src={require('../../static/images/icons/arrow-down.svg').default}
                          alt=""
                        />
                      </button>
                    </li>
                    {headerBottomMenu.map((el) => {
                      if (el.hide_mobile) {
                        return null;
                      } else if (el.new_window) {
                        return (
                          <li key={el.id}>
                            <a
                              href={linkWithUtm(el.link)}
                              target="_blank"
                              rel="nofollow noopener"
                              className={el.class}
                            >
                              {el.title}
                            </a>
                          </li>
                        );
                      } else {
                        return (
                          <li key={el.id}>
                            <a href={linkWithUtm(el.link)} className={el.class}>
                              {el.title}
                            </a>
                          </li>
                        );
                      }
                    })}
                    <li key="7">
                      <button
                        onClick={this.openSupportScreen.bind(this)}
                      >
                        <span>Поддержка</span>
                        <img
                          src={require('../../static/images/icons/arrow-down.svg').default}
                          alt=""
                        />
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="menu-mobile__main__list">
                  <ul>
                    {headerTopMenu.map((el, ind) => {
                      if (el.new_window) {
                        return (
                          <li key={ind}>
                            <a
                              href={linkWithUtm(el.link)}
                              target="_blank"
                              rel="nofollow noopener"
                              className={el.class}
                            >
                              {el.title}
                            </a>
                          </li>
                        );
                      } else if (el.tel || el.email) {
                        return (
                          <li key={ind}>
                            <a href={el.link} className={el.class}>
                              {el.title}
                            </a>
                          </li>
                        );
                      } else {
                        return (
                          <li key={ind}>
                            <a href={linkWithUtm(el.link)} className={el.class}>
                              {el.title}
                            </a>
                          </li>
                        );
                      }
                    })}
                    <li className="header-mobile__phone-info">
                      <a href="tel:+78633012000">
                        <IconPhone />
                        <span>301-20-00</span>
                      </a>
                      <div className="header-tooltip__content">
                        <p className="header-tooltip__title">Мы на связи</p>
                        <p>Пн и Сб - с 9:00 до 21:00</p>
                        <p>Вс и праздничные дни - с 9:00 до 20:00</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={`menu-mobile__clubs menu-mobile__tab ${
                this.state.clubsScreen && '_active'
              }`}
            >
              <div className="menu-mobile__tab__content">
                <ul>
                  {headerClubs.slice(0).reverse().map((el) => (
                    <li key={el.id}>
                      <a href={linkWithUtm(el.link)}>{el.title}</a>
                    </li>
                  ))}
                </ul>
                <div className="menu-mobile__clubs__card">
                  {promo ? (
                    <div className="header-offer">
                      {
                        promo.link_button
                        ? <a href={promo.link_button} target="_blank" rel="nofollow noopener"></a>
                        : null
                      }
                      <div className="header-offer__card">
                        {
                          promo.path_photo
                          ? <div className="header-offer__card__content-img" style={{backgroundImage: `url(${promo.path_photo})`}}></div>
                          : <div className="header-offer__card__content"></div>
                        }
                        <div className="header-offer__card__title">
                          <span dangerouslySetInnerHTML={{ __html: promo.name ? promo.name : '' }} />
                        </div>
                        <div className="header-offer__card__desc">
                          <p dangerouslySetInnerHTML={{ __html: promo.description ? promo.description : '' }}/>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div
              className={`menu-mobile__support menu-mobile__tab ${
                this.state.supportScreen && '_active'
              }`}
            >
              <div className="menu-mobile__tab__content">
                <div className="menu-mobile__support__item">
                  <a href={linkWithUtm("https://fitron.club/support/qa/")}></a>
                  <p className="title-link">Вопросы и ответы</p>
                  <p>
                    Мы&nbsp;собрали самые популярные вопросы о&nbsp;фитнесе
                    и&nbsp;питании.
                  </p>
                </div>
                <div className="menu-mobile__support__item">
                  <a href={linkWithUtm("https://fitron.club/support/blog/")}></a>
                  <p className="title-link">полезные статьи</p>
                  <p>
                    Самое актуальное о&nbsp;питании, фитнесе и&nbsp;здоровье.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default HeaderMobile;
